





































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import TagSetCheckBoxPicker from '@/components/registration/common/tags/TagSetCheckBoxPicker.vue';
import TagSetDropDownPicker from '@/components/registration/common/tags/TagSetDropDownPicker.vue';
import FieldMixin from '@/mixins/registration/FieldMixin';
import { TagSet } from '@/interfaces/registration/tags/TagSet';
import { TagSetModel } from '@/interfaces/registration/models/TagSetModel';

@Component({
  components: { TagSetCheckBoxPicker, TagSetDropDownPicker }
})
export default class TagSetPicker extends Mixins(FieldMixin) {
  @Prop() readonly tagSets!: Array<TagSet>;
    @Prop({ default: () => { return []; } }) readonly value!: Array<TagSetModel>;
  private collapsedPanels: { [key: number]: boolean } = {};
  private initialized = false;

  mounted () {
    this.setupBootstrapCollapse();
  }

  setupBootstrapCollapse () {
    const accordion = document.getElementById('accordion');
    if (accordion) {
      $(accordion).on('show.bs.collapse', '.panel-collapse', this.onCollapseShow);
      $(accordion).on('hide.bs.collapse', '.panel-collapse', this.onCollapseHide);
    }
  }

  onCollapseHide (event: Event) {
    const targetPanel = event.target as HTMLElement;
    $(targetPanel).prev('.panel-heading').addClass('hide-info');
  }

  onCollapseShow (event: Event) {
    const targetPanel = event.target as HTMLElement;
    $('.panel-heading').addClass('hide-info');
    $(targetPanel).prev('.panel-heading').removeClass('hide-info');
  }

  public tagPickerType (index: number): string {
    switch (this.visibleTagSets[index].inputType) {
      case 'Checkboxes':
        return 'TagSetCheckBoxPicker';
      case 'DropDown':
        return 'TagSetDropDownPicker';
    }

    return '';
  }

  @Watch('value')
  onValueChanged () {
    if (!this.initialized) {
      this.initializeCollapsedPanels();
      this.initialized = true;
    }
  }

  private initializeCollapsedPanels () {
    this.visibleTagSets.forEach((tagSet, index) => {
      if (this.getNumberOfSelected(index) > 0) {
        this.$set(this.collapsedPanels, index, true);
      }
    });
  }

  public getNumberOfSelected (index: number): number {
    const selectedTagIds: number[] = this.model[index].tags;
    const tagSetAny: any = this.visibleTagSets[index];
    const allTags: any[] = tagSetAny.tags || [];

    let count = 0;

    for (const selectedId of selectedTagIds) {
      const tag = allTags.find((t: any) => t.id === selectedId);
      if (!tag) continue;

      const hasSubTags = Array.isArray(tag.subTags) && tag.subTags.length > 0;

      if (!hasSubTags) {
        count++;
      } else {
        const hasSelectedSubTags = tag.subTags.some((subTag: any) =>
          selectedTagIds.includes(subTag.id)
        );

        if (!hasSelectedSubTags) {
          count++;
        }
      }
    }

    return count;
  }

  public clearSelection (index: number, tagSet: any): void {
    const _model = this.model;
    _model[index].tags = [];
    this.$emit('input', _model);
  }

  get model (): Array<TagSetModel> {
    const _model = this.visibleTagSets.map((tagSet) => {
      const name = 'TagSet_' + tagSet.id;
      const tags = this.value.find((v) => v.name === name)?.tags || [];
      return { name: name, tags: tags };
    });

    return _model;
  }

  public valueChanged (tagSetModel: TagSetModel): void {
    const _model = this.model;
    const tagSetIndex = _model.findIndex((value) => value.name === tagSetModel.name);
    if (tagSetIndex >= 0) {
      this.$set(_model, tagSetIndex, tagSetModel);
    }

    this.$emit('input', _model);
  }

  get visibleTagSets (): Array<TagSet> {
    const tagField = this.getField('Tag');
    if (tagField !== undefined) {
      const visibleTagSetIds = tagField.tags.map((tag) => parseInt(tag.value as string));
      return this.tagSets.filter((tagSet) => {
        return visibleTagSetIds.indexOf(tagSet.id as number) !== -1;
      });
    }

    return this.tagSets;
  }
}
